import { render, staticRenderFns } from "./LoginSelection.vue?vue&type=template&id=34b226ba&scoped=true&"
import script from "./LoginSelection.vue?vue&type=script&lang=js&"
export * from "./LoginSelection.vue?vue&type=script&lang=js&"
import style0 from "./LoginSelection.vue?vue&type=style&index=0&id=34b226ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b226ba",
  null
  
)

export default component.exports